import { BankDetailsResponse, BankDetailStatuses } from '@newday/plum-types';

export const getMockBankDetailsResponse = (
  overrides?: Partial<BankDetailsResponse>
): BankDetailsResponse =>
  ({
    status: BankDetailStatuses.success,
    ...overrides,
  } as BankDetailsResponse);
